<template>
    <div>
        <template>
            <div class="card mb-1">
                <div class="card-header d-block border-bottom">
                    <div class="text-center">
                        <span>
                            <h4 class="font-weight-bolder text-uppercase text-primary">Pendalaman Register Inventarisasi KIB
                                B
                                <br /> Tahun {{ parentFilter.tahun }}
                            </h4>
                        </span>
                    </div>
                </div>
                <div class="card-body pt-1">
                    <template v-if="(parentFilter.tahun && parentFilter.kolok > 0)">
                        <b-overlay :show="loadingGetIndex" variant="light" opacity="0.85" blur="2px" rounded="sm">
                            <div class="row">
                                <b-col cols="12">
                                    <div class="d-flex flex-md-row flex-column justify-content-between overflow-auto">
                                        <div class="mr-2 d-flex flex-column flex-wrap"
                                            style="width: max-content; gap: 5px;">
                                            <div>
                                                <span class="font-weight-bolder text-uppercase">Nama PD/UKPD/UPB</span>
                                            </div>
                                            <div>
                                                <span class="font-size-lg">{{ formDatas.nalok || '-' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                            </div>
                        </b-overlay>
                        <hr />
                    </template>
                    <template v-if="!statusRegisterB && (parentFilter.tahun && parentFilter.kolok > 0)">
                        <div class="row p-1">
                            <div class="col-12 border border-1 p-1 rounded text-center bg-light-warning">
                                <div class="text-warning font-weight-bold text-uppercase">Peringatan !</div>
                                <span>Proses pendalaman register BMD Inventarisasi KIB B tidak dapat dilakukan
                                    sebelum daftar BMD telah divalidasi oleh kepala PD/UKPD/UPB</span>
                            </div>
                        </div>
                    </template>
                    <div class="row">
                        <div class="col-12">
                            <div>
                                <span class="text-muted text-uppercase font-medium-1 font-weight-bold">Filter Table</span>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-6">
                                    <b-form-group label="Status" label-for="statusFilterTable">
                                        <b-overlay :show="isLoadStatusHasilSensus" variant="light" opacity="0.85" blur="2px"
                                            rounded="sm">
                                            <v-select v-model="formFilterTable.filter_status" label="text"
                                                :options="dsStatusHasilSensus" @input="handleSearch" />
                                        </b-overlay>
                                    </b-form-group>
                                </div>
                                <div class="col-12 col-md-6 col-lg-6">
                                    <b-form-group label="Permasalahan BMD" label-for="permasalahanFilterTable">
                                        <v-select v-model="formFilterTable.filter_permasalahan_bmd" label="text"
                                            :options="optProblemBmd" @input="handleSearch" />
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <b-input-group>
                            <b-input-group-prepend>
                                <v-select id="searchOpt" class="search-filter-option-select"
                                    v-model="formFilterTable.key_cari" label="text" :options="searchOptions" />
                            </b-input-group-prepend>
                            <b-form-input id="Kata" v-model="formFilterTable.cari"
                                placeholder="Pencarian data BMD, pilih kata kunci pencarian lalu tekan enter" type="text"
                                class="d-inline-block" @keyup.enter="handleSearch" />
                        </b-input-group>
                        <!-- <b-col cols="12">
                            <b-form-group label="Pencarian" label-for="pencarianFilterTable">
                                <b-form-input id="search-data-bmd" v-model="formFilterTable.cari"
                                    placeholder="Pencarian data pendalaman register, ketik kata kunci pencarian lalu tekan enter"
                                    type="text" class="d-inline-block" @keyup.enter="handleSearch" />
                            </b-form-group>
                        </b-col> -->
                    </b-row>
                    <hr />
                    <div class="row mb-2">
                        <div class="col-12">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <span class="text-muted text-uppercase font-medium-1 font-weight-bold">Tabel Daftar
                                        Pendalaman
                                        Register </span>
                                </div>
                                <div v-if="!isFinal">
                                    <div
                                        v-if="(closeSistemInformation.isOpen) && statusRegisterB && (parentFilter.tahun && parentFilter.kolok > 0) && $can('Buat', 'b-pendalaman-register')">
                                        <b-button id="input" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                            :to="{ name: 'bPendalamanRegisterTambah', query: { tahun: parentFilter.tahun, kolok: parentFilter.kolok } }">
                                            <feather-icon icon="PlusIcon" class="mr-50" />
                                            <span class="align-middle">Input</span>
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <vue-good-table theme="polar-bear" :columns="columns" :rows="rows" :pagination-options="{
                                enabled: true, perPage: row, jumpFirstOrLast: true,
                            }" :totalRows="totalRecords" :isLoading="isLoadingTable" mode="remote"
                                @on-sort-change="onSortChange">
                                <template slot="table-row" slot-scope="props">
                                    <div v-if="props.column.field === 'aksi'" style="margin-left: 6px">
                                        <b-button variant="primary" v-b-tooltip.hover title="Detail Pendalaman Register"
                                            class="btn-icon" @click="openDetailDataDialog(props)">
                                            <feather-icon icon="InfoIcon" />
                                        </b-button>
                                    </div>
                                    <div v-else-if="props.column.field === 'tgl_oleh'" class="text-right">
                                        <span>
                                            <span>{{ parserValue('dateOnly', props.row['tgl_oleh']) || '-' }}</span>
                                        </span>
                                    </div>
                                    <div v-else-if="props.column.field === 'total_harga'" class="text-right">
                                        <span>
                                            {{ `${new Intl.NumberFormat('id-ID', {
                                                maximumFractionDigits: 2,
                                            }).format(props.formattedRow[props.column.field])}` }}
                                        </span>
                                    </div>
                                    <div v-else-if="props.column.field === 'jenis_pendalaman'">
                                        <div class="">
                                            <div class="text-nowrap d-flex flex-row justify-content-between">
                                                <div>
                                                    <span class="align-text-top font-weight-bolder text-capitalize mr-4">{{
                                                        props.row['jenis_pendalaman'] }}</span>
                                                </div>
                                                <div v-b-tooltip.hover.top="'Status Validasi'" class="d-flex flex-row"
                                                    style="gap: 2px">
                                                    <div>
                                                        <b-badge :variant="badgeStatus(props.row.status_hasil_sensus)">
                                                            <feather-icon icon="CheckCircleIcon" class="mr-25" />
                                                            {{ props.row['nama_status_hasil_sensus'] }}
                                                        </b-badge>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr class="my-25" />
                                            <div class="text-nowrap mb-25 d-flex justify-content-start">
                                                <span class="align-text-top font-small-5">
                                                    ID : {{ props.row['pendalaman_id'] }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        {{ props.formattedRow[props.column.field] }}
                                    </div>
                                </template>
                                <template slot="pagination-bottom">
                                    <div class="d-flex justify-content-between flex-wrap">
                                        <div class="d-flex align-items-center mb-0 mt-1">
                                            <span class="text-nowrap"> Menampilkan 1 hingga </span>
                                            <b-form-select v-model="row" :options="['10', '25', '50']" class="mx-1"
                                                @input="handlePageChange" />
                                            <span class="text-nowrap">
                                                dari {{ totalRecords }} entri
                                            </span>
                                        </div>
                                        <div>
                                            <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number
                                                last-number align="right" prev-class="prev-item" next-class="next-item"
                                                class="mt-1 mb-0" @change="handleChangePage">
                                                <template #prev-text>
                                                    <feather-icon icon="ChevronLeftIcon" size="18" />
                                                </template>
                                                <template #next-text>
                                                    <feather-icon icon="ChevronRightIcon" size="18" />
                                                </template>
                                            </b-pagination>
                                        </div>
                                    </div>
                                </template>
                            </vue-good-table>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </template>
        <ModalDetailPendalamanRegister :show="showModalDetailData" :data-modal="modalDetailData"
            @closeDialog="closeDetailDataDialog" />
    </div>
</template>
  
<script>
import { ref, watchEffect } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import skTim from "@/composables/b/skTim";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { showNotifikasi } from '@/libs/helper';
import pendalamanRegister from "@/composables/b/pendalamanRegister";
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import { VBTooltip, BButton } from 'bootstrap-vue'
import store from '@/store/index'
import ModalDetailPendalamanRegister from '../components/ModalDetailPendalamanRegister.vue';
import masterBRef from "@/composables/master/masterBRef";
import { parserValue } from '@/libs/helper'
import searchOpt from "@/composables/b/searchOpt";
import { closeSistemKibB } from '@/libs/helper';

export default {
    props: {
        fd: { type: Object, required: true },
        parentFilter: { type: Object, required: true }
    },
    setup(props, context) {
        //global variable
        const g = context.root;
        const $route = g.$route;
        const formDatas = ref({});
        const loadingGetIndex = ref(false);
        const statusRegisterB = ref(false);
        const isFinal = ref(false);
        const getData = () => {
            let params = props.parentFilter;
            if (params.kolok > 0) {
                loadingGetIndex.value = true;
                pendalamanRegister.getIndexDetail(g, params).then(res => {
                    formDatas.value = { ...formDatas.value, ...res.data }
                    loadingGetIndex.value = false;
                    statusRegisterB.value = res.statusRegisterB;
                    isFinal.value = Boolean(Number(res.is_final));
                }).catch(err => {
                    statusRegisterB.value = false;
                    loadingGetIndex.value = false;
                    console.log(err)
                });
            }
        };
        getData();

        const isLoadStatusHasilSensus = ref(false);
        const dsStatusHasilSensus = ref([]);
        const getDsStatusHasilSensus = () => {
            isLoadStatusHasilSensus.value = true;
            dsStatusHasilSensus.value = [];
            let params = {
                filter_platform: 'semua',
            }
            masterBRef.getStatusHasilSensusDs(g, params).then(res => {
                if (res.success) {
                    res.rows.unshift({ text: '-- Semua --', value: 'semua' })
                    dsStatusHasilSensus.value = res.rows;
                }
                isLoadStatusHasilSensus.value = false;
            }).catch(err => {
                isLoadStatusHasilSensus.value = false;
                dsStatusHasilSensus.value = [];
                console.log(err)
            });
        };
        getDsStatusHasilSensus();

        //variable untuk table
        const start = ref(0);
        const rows = ref([]);
        const row = ref(10);
        const totalRecords = ref(0);
        const sortColumn = ref("");
        const order = ref("");
        const isLoadingTable = ref(false);
        const formFilterTable = ref({
            filter_status: { text: '-- Semua --', value: 'semua' },
            filter_permasalahan_bmd: { text: '-- Semua --', value: 'semua' },
            cari: null,
            key_cari: { text: '-- Pilih Key --', value: '' },
        });

        const filterValue = ref({
            filter_status: 'semua',
            filter_permasalahan_bmd: 'semua',
            kolok: null,
            limit: row.value,
            start: start.value,
            cari: null,
            key_cari: { text: '-- Pilih Key --', value: '' },
        })
        const getDataBmd = () => {
            isLoadingTable.value = true;
            filterValue.value.kolok = props.parentFilter.kolok;
            filterValue.value.filter_kolok = props.parentFilter.kolok;
            filterValue.value.filter_status = formFilterTable.value.filter_status.value;
            filterValue.value.filter_permasalahan_bmd = formFilterTable.value.filter_permasalahan_bmd.value;
            filterValue.value.cari = formFilterTable.value.cari;
            filterValue.value.key_cari = (formFilterTable.value.key_cari) ? formFilterTable.value.key_cari.value : '';

            pendalamanRegister.getDataPendalamanRegister(g, filterValue.value).then(resp => {
                if (resp.success) {
                    rows.value = resp.rows;
                    totalRecords.value = resp.totalRows;
                } else {
                    rows.value = [];
                    totalRecords.value = 0;
                }
                isLoadingTable.value = false;
            }).catch((err) => {
                console.log(err)
                isLoadingTable.value = false;
            });
        };
        getDataBmd();

        const handleSearch = (searching) => {
            filterValue.value.start = 0;

            getDataBmd();
        };

        const handlePageChange = (length) => {
            filterValue.value.limit = length;
            getDataBmd();
        };

        const handleChangePage = (page) => {
            filterValue.value.start = (page - 1) * row.value;
            getDataBmd();
        };

        const onSortChange = (params) => {
            sortColumn.value = params[0].field;
            order.value = params[0].type;
            getDataBmd();
        };
        /* On Mounted */
        /* ------------------------------- */
        /* Modal Validasi P3B */
        const modalDetailData = ref({});
        const showModalDetailData = ref(false);
        const openDetailDataDialog = (item) => {
            showModalDetailData.value = true;
            modalDetailData.value = item.row;
        };
        const closeDetailDataDialog = (item) => {
            showModalDetailData.value = false;
        };

        /* Search Option */
        const searchOptions = ref([]);
        const getSearchOptions = () => {
            searchOpt.getSearchOpt(g, { list: 'pendalaman' }).then(resp => {
                if (resp.success) {
                    searchOptions.value = resp.rows
                } else {
                }
                searchOptions.value.unshift({ text: '-- Pilih Key --', value: '' })

            }).catch(err => {
                console.log(err)
            })
        };
        getSearchOptions();
        const closeSistemInformation = ref({});
        setInterval(() => {
            closeSistemInformation.value = closeSistemKibB();
        }, 1000);
        return {
            statusRegisterB,
            parserValue,
            loadingGetIndex,
            getData,
            getDataBmd,
            formDatas,

            isLoadStatusHasilSensus,
            dsStatusHasilSensus,

            /* Table */
            formFilterTable,
            handleSearch,
            handlePageChange,
            handleChangePage,
            onSortChange,
            rows,
            start,
            row,
            totalRecords,
            sortColumn,
            order,
            isLoadingTable,

            /* Modal Detail Data */
            showModalDetailData,
            modalDetailData,
            openDetailDataDialog,
            closeDetailDataDialog,

            searchOptions,
            closeSistemInformation,
            isFinal
        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        VueGoodTable,
        vSelect,
        ModalDetailPendalamanRegister,
    },
    watch: {
        parentFilter: {
            handler(newVal, oldVal) {
                this.getData();
                this.getDataBmd();
            },
            deep: true
        }
    },
    methods: {
        changeStateEvent(event) {
            this.$emit('changeStateEvent', event);
        },
        badgeStatus(status) {
            if (status == 'dikirim') {
                return 'light-secondary';
            } else if (status == 'disetujui') {
                return 'light-success';
            } else if (status == 'dikembalikan') {
                return 'light-danger';
            }
        },
    },
    data() {
        return {
            imgUrl: require('@/assets/images/pages/coming-soon.svg'),
            required,
            optFPlatformInput: [
                { text: '-- Semua --', value: '' },
                { text: 'Mobile', value: 'mobile' },
                { text: 'Desktop', value: 'desktop' }
            ],
            optProblemBmd: [
                { text: '-- Semua --', value: '' },
                { text: 'Biaya Biaya', value: 'biaya-biaya' },
                { text: 'Fisik Tidak Ditemukan', value: 'fisik-tidak-ditemukan' }
            ],
            columns: [
                {
                    label: "Aksi",
                    field: "aksi",
                    width: '70px',
                    thClass: 'text-uppercase bg-light-primary pb-1 px-0 text-center',
                    sortable: false,
                },
                {
                    label: "Permasalahan BMD",
                    field: "jenis_pendalaman",
                    width: '200px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Guid Aset",
                    field: "guid_aset",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Kolok",
                    field: "kolok",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nalok",
                    field: "nalok",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Register",
                    field: "noreg_108",
                    width: '175px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Kode Barang",
                    field: "kobar_108",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nama Barang",
                    field: "nabar_108",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Tanggal Perolehan",
                    field: "tgl_oleh",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Total Harga",
                    field: "total_harga",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Bahan",
                    field: "nama_bahan",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Merk",
                    field: "merk",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Tipe",
                    field: "tipe",
                    width: '350px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Chasis",
                    field: "nochasis",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Mesin",
                    field: "nomesin",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor Polisi",
                    field: "nopol",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nomor BPKB",
                    field: "nobpkb",
                    width: '190px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
            ],
        };
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>